import { apiRequest } from '@/utils/api-request';
import { Dataset } from '@/types/source-types';
import { useOrgStore } from '@/stores/org-store';

interface GetDatasetsResponse {
  datasets: Dataset[];
}

export const getDatasets = async (collectionId: string) => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<GetDatasetsResponse>({
    url: `/collections/${orgId}/${collectionId}/datasets`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to fetch datasets',
    };
  }

  return response?.data?.datasets ?? [];
};
